<template>
  <div class="flex justify-center items-center">
    <div class="w-1/2 flex h-screen bg-blue justify-center items-center">
      <h1 class="text-3xl font-semibold text-blue-lightest"> Doctor Dashboard </h1>
    </div>
    <div v-if="showBackUpCodes" class="w-1/2 flex flex-col h-screen justify-center items-center">
      <div class="w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <label class="block text-grey-darker text-xl font-semibold mb-2">
          Multi-Factor Authentication
        </label>
        <p class="text-lg text-grey-dark mt-2 leading-normal font-semibold">Back-up Codes</p>
        <p class="text-base text-grey-dark my-6">keep this backup codes safe incase you lose access to the authenticator app</p>
        <div class="ml-8 bg-grey-lightest rounded-m w-3/4 shadow-inner hover:shadow-sm p-6">
          <p @click="copyCodesToClip" class="float-right w-max text-sm cursor-pointer hover:underline font-semibold text-grey-dark">{{ copyCodes }}</p>
          <div class="grid-container text-grey-darker ml-8 mt-2">
            <div class="mt-4 grid-item" v-for="item in backUpCodes" :key="item">{{ item }}</div>
          </div>
        </div>
        <p class="text-base text-grey-dark mt-8 mb-4">Multi-factor authentication has been set-up successfully</p>
        <div class="flex items-center justify-between mt-4">
            <button @click="goBackToLogin" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              Login
            </button>
        </div>
      </div>
    </div>
    <div v-else class="w-1/2 flex flex-col h-screen justify-center items-center">
      <div v-if="enableViaAuthApp" class="w-2/3 flex flex-col h-screen justify-center items-center">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div @click="goBack" class="cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold">
            <i class="fas fa-arrow-left"></i> Back
          </div>
          <div class="mb-6">
            <label class="block text-grey-darker text-base font-semibold mb-4">
              Connect an Authenticator App
            </label>
            <p class="mb-4 text-grey-dark">
              Connect an authenticator app that generates verification codes. You can use the codes when we need to verify your identity.
            </p>
            <div class="text-grey-dark mx-3 text-base">
              <ol class="order-list">
                <li>Download and install an authenticator app on your mobile device.</li>
                <li>Use the app to scan this QR code.</li>
                <li>Enter the code generated by the app.</li>
              </ol>
            </div>
          </div>
          <div class="ml-10 mt-4 mb-8">
            <div v-if="showQR">
              <img :src='qrCode' alt="qr_code" style="height: 184px; width: 184px; margin-left: 108px;">
            </div>
            <div v-else>
              <p class="mt-6 ml-6 text-grey-dark tracking-widest text-lg font-semibold uppercase">{{ altCode }}</p>
            </div>
          </div>
          <label class="block text-grey-darker text-sm font-semibold mt-4 mb-2 uppercase tracking-widest">
            Verification Code
          </label>
          <input class="shadow appearance-none border rounded w-1/2 py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline" id="otp" type="text" placeholder="Code" v-model="otp_code" 
            value=""
            maxlength="10"
            :has-counter="false">
          <div class="flex items-center justify-between mt-4">
            <button type="button" @click="configMfaSettings" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              Connect
            </button>
            <div @click="showMfaQr" class="cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold">
              <a href="#">{{ showQRText }}</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="enableViaOtp" class="w-2/3 flex flex-col h-screen justify-center items-center">
        <div class="bg-white shadow-md rounded px-16 pt-6 pb-8 mb-4">
          <div @click="goBack" class="cursor-pointer text-sm italic mb-6 text-grey-dark hover:text-blue hover:font-semibold">
            <i class="fas fa-arrow-left"></i> Back
          </div>
          <div class="mb-6">
            <label class="block text-grey-darker text-base font-semibold mb-4">
              Enter OTP
            </label>
            <p class="text-base text-grey-dark mb-8">OTP has been sent to your registered e-mail</p>
            <label class="block text-grey-darker text-sm font-semibold mb-2">
              OTP
            </label>
            <input class="shadow appearance-none border rounded w-full py-2 px-3 mb-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline" id="otp" type="text" placeholder="Code" v-model="otp_code" 
              value=""
              maxlength="10"
              :has-counter="false">
          </div>
          <div class="flex items-center justify-between mt-4">
            <button type="button" @click="configMfaSettings" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              Submit
            </button>
            <div @click="resendOTP" class="cursor-pointer text-sm italic text-grey-dark hover:text-blue hover:font-semibold">
              <a href="#">Resend OTP</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div class="mb-6">
          <label class="block text-grey-darker text-base font-semibold mb-4">
            Register a Verification Method
          </label>
          <div class="text-grey-dark">
            <div @click="viaAuthenticatorApp" class="border mb-3 rounded-m w-3/4 p-3 cursor-pointer hover:bg-blue-lightest">
              <h3 class="text-base">Authenticator App</h3>
              <p class="text-sm mt-1">Connect an authenticator app</p>
            </div>
            <div @click="viaOtp" class="border rounded-m p-3 w-3/4 cursor-pointer hover:bg-blue-lightest">
              <h3 class="text-base">One Time Password Generator</h3>
              <p class="text-sm mt-1">Receive OTP on your registered e-mail</p>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between mt-4">
          <button @click="goBackToLogin" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router/index.js'
import {mapState} from 'vuex'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'

Vue.use(VueToast)
export default {
  data () {
    return {
      isLoading: false,
      otp_code: '',
      backUpCodes: [],
      copyCodes: 'copy',
      showBackUpCodes: false,
      enableViaAuthApp: false,
      enableViaOtp: false,
      showQR: true,
      altCode: '',
      qrCode: '',
      showQRText: "I Can't Scan the QR Code"
    }
  },
  computed: {
    ...mapState({
      role: state => state.configuration.role
    })
  },
  methods: {
    goBack: function () {
      this.enableViaAuthApp = false
      this.enableViaOtp = false
      this.showBackUpCodes = false
      this.otp_code = ''
    },
    goBackToLogin: function () {
      this.enableViaAuthApp = false
      this.enableViaOtp = false
      sessionStorage.removeItem('mfa_token')
      sessionStorage.removeItem('mfa_enabled')
      router.push('login')
    },
    viaAuthenticatorApp: function () {
      this.enableViaAuthApp = true
      this.isLoading = true
      var options = { mfa_token: sessionStorage.getItem('mfa_token') }
      this.$http.post(window.API_URL + 'doctors/mfa_settings/qr_code', options).then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.altCode = response.body.alternative_code
          let qrCode = response.body.qr_code
          this.qrCode = `data:image/svg+xml;base64,${btoa(qrCode)}`
        }
      }).catch(function () {
        this.isLoading = false
        this.$toast.open({
          message: 'Failed to generate QR-code',
          type: 'error',
          position: 'top',
          queue: false
        })
        this.enableViaAuthApp = false
      })
    },
    viaOtp: function () {
      this.enableViaOtp = true
      this.isLoading = true
      var options = { mfa_token: sessionStorage.getItem('mfa_token') }
      this.$http.post(window.API_URL + 'doctors/mfa_settings/otp_code', options).then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          })
        }
      }).catch(function () {
        this.isLoading = false
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        })
        this.enableViaOtp = false
      })
    },
    configMfaSettings: function () {
      this.isLoading = true
      var options = {
        mfa_token: sessionStorage.getItem('mfa_token'),
        otp_code: this.otp_code
      }
      if (this.otp_code !== '') {
        this.$http.post(window.API_URL + 'doctors/mfa_settings', options).then(response => {
          this.showBackUpCodes = true
          this.enableViaAuthApp = false
          this.enableViaOtp = false
          if (response.status === 200) {
            this.isLoading = false
            this.backUpCodes = response.body.backup_codes
            this.$toast.open({
              message: response.body.message,
              type: 'success',
              position: 'top',
              queue: false
            })
          }
        }).catch(error => {
          this.isLoading = false
          this.$toast.open({
            message: error.body.message || 'Something went wrong!',
            type: 'error',
            position: 'top',
            queue: false
          })
        })
      }
    },
    showMfaQr: function () {
      if (this.showQR) {
        this.showQRText = 'Scan a QR Code'
      } else {
        this.showQRText = "I Can't Scan the QR Code"
      }
      this.showQR = !this.showQR
    },
    resendOTP: function () {
      this.isLoading = true
      var options = { mfa_token: sessionStorage.getItem('mfa_token') }
      this.$http.post(window.API_URL + 'doctors/mfa_settings/resend_otp', options).then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          })
        }
      }).catch(function () {
        this.isLoading = false
        this.enableViaOtp = false
        this.$toast.open({
          message: 'MFA token expired!',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    },
    copyCodesToClip: function () {
      this.copyCodes = 'copied!'
      const textToCopy = this.backUpCodes.join(', ')
      const tempTextarea = document.createElement('textarea')
      tempTextarea.value = textToCopy
      document.body.appendChild(tempTextarea)
      tempTextarea.select()
      document.execCommand('copy')
      this.$toast.open({
        message: 'Text copied to clipboard',
        type: 'success',
        position: 'top',
        queue: false
      })
      document.body.removeChild(tempTextarea)
      setTimeout(() => {
        this.copyCodes = 'copy'
      }, 1500)
    }
  }
}

</script>

<style lang="scss" scoped>
$danger: hsl(348, 100%, 61%);
.error-text
{
  color:$danger;
  margin-bottom:10px;
}
.title {
  text-align:center;
}
.order-list{
  list-style-type: disc;
  list-style-position: outside;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/MFASettings.vue